export const dealjacketConstants = {
  DEALJACKET_LIST_REQUEST: "DEALJACKET_LIST_REQUEST",
  DEALJACKET_LIST_SUCCESS: "DEALJACKET_LIST_SUCCESS",
  DEALJACKET_LIST_FAILURE: "DEALJACKET_LIST_FAILURE",

  DEALJACKET_DETAIL_REQUEST: "DEALJACKET_DETAIL_REQUEST",
  DEALJACKET_DETAIL_SUCCESS: "DEALJACKET_DETAIL_SUCCESS",
  DEALJACKET_DETAIL_FAILURE: "DEALJACKET_DETAIL_FAILURE",

  DEALJACKET_UPLOAD_REQUEST: "DEALJACKET_UPLOAD_REQUEST",
  DEALJACKET_UPLOAD_SUCCESS: "DEALJACKET_UPLOAD_SUCCESS",
  DEALJACKET_UPLOAD_FAILURE: "DEALJACKET_UPLOAD_FAILURE",

  DEALJACKET_EDIT_REQUEST: "DEALJACKET_EDIT_REQUEST",
  DEALJACKET_EDIT_SUCCESS: "DEALJACKET_EDIT_SUCCESS",
  DEALJACKET_EDIT_FAILURE: "DEALJACKET_EDIT_FAILURE",

  DEALJACKET_EDIT_NAME_REQUEST: "DEALJACKET_EDIT_NAME_REQUEST",
  DEALJACKET_EDIT_NAME_SUCCESS: "DEALJACKET_EDIT_NAME_SUCCESS",
  DEALJACKET_EDIT_NAME_FAILURE: "DEALJACKET_EDIT_NAME_FAILURE",

  DEALJACKET_CHECK_DEAL_NUMBER_REQUEST: "DEALJACKET_CHECK_DEAL_NUMBER_REQUEST",
  DEALJACKET_CHECK_DEAL_NUMBER_SUCCESS: "DEALJACKET_CHECK_DEAL_NUMBER_SUCCESS",
  DEALJACKET_CHECK_DEAL_NUMBER_FAILURE: "DEALJACKET_CHECK_DEAL_NUMBER_FAILURE",

  DEALJACKET_UPLOAD_MULTIPLE_FILES_REQUEST: "DEALJACKET_UPLOAD_MULTIPLE_FILES_REQUEST",
  DEALJACKET_UPLOAD_MULTIPLE_FILES_SUCCESS: "DEALJACKET_UPLOAD_MULTIPLE_FILES_SUCCESS",
  DEALJACKET_UPLOAD_MULTIPLE_FILES_FAILURE: "DEALJACKET_UPLOAD_MULTIPLE_FILES_FAILURE",

  SEARCH_REQUEST: "SEARCH_REQUEST",
  SEARCH_SUCCESS: "SEARCH_SUCCESS",
  SEARCH_FAILURE: "SEARCH_FAILURE",

  DEALJACKET_CLEAR_SEARCH: "SEARCH_CLEAR",

  CLEAR_JACKETS: "CLEAR_JACKETS",
};
